import React from 'react';
import PropTypes from 'prop-types';
import SearchInput from '../../common/components/_SearchBox';


function GenericVideosFilter({ search, filters, settings }) {

	return (
        <div className="filter-bar">
            <div className="filter__text">
                Filter by
            </div>
            <SearchInput search={search} settings={settings}/>
        </div>
	);
}

GenericVideosFilter.propTypes = {
    search: PropTypes.object,
    filters: PropTypes.object,
    settings: PropTypes.object,
};

export default GenericVideosFilter;
